
import Crop from "../../../assets/filled/Crop.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CropIcon({ className, dataTestid = "CropIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Crop data-testid={dataTestid} className={classes} {...rest} />
  );
}
